// @flow strict
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { withDecoratedNodes } from '@mondough/contentful/src/richTextDecorators'
import { type Location, SEOHead } from '@mondough/public-web-components'
import { graphql, withPrefix } from 'gatsby'
import idx from 'idx'
import React from 'react'
import { prefixHttpsToUrl } from '../../../app.blog/src/utils/stringUtils/es6'
import { type singleFeaturePage } from '../../__types__/singleFeaturePage'
import { renderFeaturePageOptions } from '../contentful/contentSectionsRenderer'
import Global from '../Global'
import { contentfulClient, ContentfulContext } from '../utils/contentfulUtils'

export const WEB_SLUGS = {
  PLUS: '/monzo-plus',
  PREMIUM: '/monzo-premium',
}
export type Props = {
  data: singleFeaturePage,
  pageContext: {
    id: string,
    siteUrl: string,
  },
  location: Location,
}

const FeaturePage = ({
  location,
  data: { contentfulCmsFeaturePage },
  pageContext: { siteUrl },
}: Props) => {
  const {
    ogImage,
    ogDescription,
    title,
    contentSections,
    canonicalURL,
    noindex,
    webSlug,
    theme = 'default',
  } = contentfulCmsFeaturePage || {}
  const imageUrl = idx(ogImage, _ => _.file.url)

  // Flow was getting angry that the contentful auto-gen type was string and not Theme so I'm appeasing it
  const pageTheme =
    ((theme === 'paid' ||
      theme === 'default' ||
      theme === 'business' ||
      theme === 'usa') &&
      theme) ||
    'default'

  return (
    <ContentfulContext.Provider value={contentfulClient}>
      <Global
        location={location}
        theme={pageTheme}
        pageMetadata={
          <SEOHead
            description={ogDescription && ogDescription.ogDescription}
            imageUrl={imageUrl != null ? prefixHttpsToUrl(imageUrl) : ''}
            pageTitle={title}
            canonicalUrl={`${siteUrl}${withPrefix(canonicalURL || webSlug)}`}
            pageUrl={`${siteUrl}${withPrefix(canonicalURL || webSlug)}`}
            noindex={noindex}
          />
        }
      >
        <div>
          {contentSections &&
            documentToReactComponents(
              withDecoratedNodes(contentSections),
              renderFeaturePageOptions(pageTheme),
            )}
        </div>
      </Global>
    </ContentfulContext.Provider>
  )
}

export default FeaturePage

/***************************
 *          QUERY
 ***************************/

export const query = graphql`
  query singleFeaturePage($id: String!) {
    contentfulCmsFeaturePage(id: { eq: $id }) {
      webSlug
      title
      ogImage {
        file {
          url
        }
      }
      ogDescription {
        ogDescription
      }
      contentSections {
        content: json
      }
      canonicalURL
      theme
      noindex
    }
  }
`
